export function cellphone(input: string) {
  return `(${input.substring(0, 2)}) ${input.substring(2)}`
}
